import {routeConfig} from '$utils';
import {priviledges} from '$consts';

export default [
  routeConfig('Admin', {title: 'Admin', ...priviledges.A}, () => import('../views/Admin.vue')),
];
